<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        :id="`popover-create`"
        class="btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <div class="inner-header--create">
              <strong class="mr-auto"> Crea un nuovo prodotto </strong>
              <b-button
                class="btn btn--create btn--smaller"
                type="button"
                variant="primary"
                size="sm"
                @click="onAdd"
                title="Crea un nuovo prodotto"
                :disabled="!canVerb(resource, 'store')"
              >
                <base-icon name="circled_plus" width="16" height="16" />
                <span>Crea</span>
              </b-button>
            </div>
            <div class="inner-header--info">
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </div>
          </div>
        </template>
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-input
                name="code"
                type="text"
                label="Codice prodotto"
                v-model="filter.byAttribute.code"
                placeholder="Inserisci un codice prodotto"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="title"
                type="text"
                label="Titolo del prodotto"
                v-model="filter.byAttribute.title"
                placeholder="Inserisci una descrizione"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="Compagnia"
                label="Compagnia"
                :options="companies"
                v-model="filter.byInsurer.id"
                @input="onInputInsurer"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="Tipo"
                label="Tipo"
                :options="risks"
                v-model="filter.byRiskType.id"
                :taggable="false"
                :multiple="true"
                :closeOnSelect="false"
                @input="onInputRisk"
              />
              <!-- <b-button
                type="button"
                variant="light"
                size="sm"
                @click="selectAllRisks()"
                >Seleziona tutti</b-button
              >

              <b-button
                type="button"
                variant="light"
                size="sm"
                @click="deselectAllRisks()"
                >Deseleziona tutti</b-button
              > -->
              <b-button
                :pressed.sync="myToggleR"
                variant="light"
                class="mt-1 btn--smaller btn--x-smaller btn--transparent"
                @click="myToggleR ? selectAllRisks() : deselectAllRisks()"
                >{{ myToggleR ? "Deseleziona tutti" : "Seleziona tutti" }}
              </b-button>
            </div>
            <div class="filter-item">
              <base-select
                name="Ramo"
                label="Ramo"
                :options="risk_branches"
                v-model="filter.byRiskBranch.id"
                :multiple="true"
                :closeOnSelect="false"
                @input="onInputBranch"
              />

              <!-- <b-button
                type="button"
                variant="light"
                size="sm"
                @click="selectAllBranches()"
                >Seleziona tutti</b-button
              >

              <b-button
                type="button"
                variant="light"
                size="sm"
                @click="deselectAllBranches()"
                >Deseleziona tutti</b-button
              > -->
              <b-button
                :pressed.sync="myToggleB"
                variant="light"
                class="mt-1 btn--smaller btn--x-smaller btn--transparent"
                @click="myToggleB ? selectAllBranches() : deselectAllBranches()"
                >{{ myToggleB ? "Deseleziona tutti" : "Seleziona tutti" }}
              </b-button>
            </div>
            <div class="filter-item">
              <base-select
                name="Prodotto"
                label="Prodotto"
                :options="products"
                v-model="filter.byInsuranceRisk.id"
                :taggable="false"
                :multiple="true"
                :closeOnSelect="false"
              />
              <!-- <b-button
                type="button"
                variant="light"
                size="sm"
                @click="selectAllProducts()"
                >Seleziona tutti</b-button
              >

              <b-button
                type="button"
                variant="light"
                size="sm"
                @click="deselectAllProducts()"
                >Deseleziona tutti</b-button
              > -->
              <b-button
                :pressed.sync="myToggleP"
                variant="light"
                class="mt-1 btn--smaller btn--x-smaller btn--transparent"
                @click="myToggleP ? selectAllProducts() : deselectAllProducts()"
                >{{ myToggleP ? "Deseleziona tutti" : "Seleziona tutti" }}
              </b-button>
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <insurance-risks
        @edit="onEdit"
        @manualFetch="manualFetch"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :filterCount="countActiveFilters"
        :performedSearch="computePerformedSearch"
        :filterName="filterName"
        :filterOn="{ byRelations: ['byInsurer'] }"
        :onlyActions="['edit', 'destroy']"
        @destroy="onDestroy"
        :ref="tableRef"
      ></insurance-risks>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import InsuranceRisks from "../../../tables/InsuranceRisks.vue";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import { mapGetters, mapActions } from "vuex";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      myToggleR: false,
      myToggleB: false,
      myToggleP: false,
      repository: "insurance_risk",
      resource: "insurance_risks",
      context: "companies_products_insurance_risks",
      filterName: "filterInsuranceRisk",
      filter: this.initFilter(),
      activeFilters: {},
      performedSearch: false,
      items: [],
      companies: [],
      risk_branches: [],
      risks: [],
      products: [],
      tableRef: "InsuranceRiskTableRef",
      fields: [
        {
          key: "custom_code",
          label: this.getDictionary("custom_code", "insurance_risk"),
        },
        {
          key: "risk_branch.code",
          label: this.getDictionary("code", "risk_branch"),
          sortable: true,
          sortKey: "byRiskBranch.code",
        },
        {
          key: "risk_branch.title",
          label: this.getDictionary("title", "risk_branch"),
          sortable: true,
          sortKey: "byRiskBranch.title",
        },
        {
          key: "code",
          label: this.getDictionary("code", "insurance_risk"),
        },
        {
          key: "title",
          label: this.getDictionary("title", "insurance_risk"),
          sortable: true,
          sortKey: "title",
        },
        {
          key: "insurer.title",
          label: this.getDictionary("insurer"),
          sortable: true,
          sortKey: "byInsurer.title",
        },
        {
          key: "delay_days",
          label: this.getDictionary("delay_days", "insurance_risk"),
          sortable: false,
          sortKey: "delay_days",
        },
      ],
    };
  },
  components: {
    BaseIcon,
    InsuranceRisks,
    BaseInput,
    BaseSelect,
  },
  mounted() {
    this.companies = this.getInsurers();
    this.risk_branches = this.getBranches()(this.filter.byInsurer.id);
    this.risks = this.getRisks();
    this.$refs[this.tableRef].fetch();
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    initFilter() {
      let init = {
        byAttribute: {
          id: null,
          title: null,
          code: null,
        },
        byInsuranceRisk: {
          id: null,
        },
        byInsurer: {
          id: null,
        },
        byRiskBranch: {
          id: null,
        },
        byRiskType: {
          id: null,
        },
      };
      return init;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onInputInsurer(insurer) {
      this.filter.byInsurer.id = insurer;
      this.filter.byRiskBranch.id = null;
      this.risk_branches = this.getBranches()(insurer);
      this.filter.byInsuranceRisk.id = null;
      if (insurer) {
        this.products = this.getProducts()(
          this.filter.byInsurer.id,
          this.filter.byRiskBranch.id,
          this.filter.byRiskType.id,
        );
      } else {
        this.products = [];
      }
    },
    deselectAllBranches() {
      this.filter.byRiskBranch.id = [];
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        this.filter.byRiskType.id,
      );
    },
    deselectAllRisks() {
      this.filter.byRiskType.id = [];
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        this.filter.byRiskType.id,
      );
    },
    deselectAllProducts() {
      this.filter.byInsuranceRisk.id = [];
    },
    selectAllBranches() {
      this.filter.byRiskBranch.id = this.risk_branches.map(
        (branch) => branch.value,
      );
    },
    selectAllRisks() {
      this.filter.byRiskType.id = this.risks.map((risk) => risk.value);
    },
    selectAllProducts() {
      this.filter.byInsuranceRisk.id = this.products.map(
        (product) => product.value,
      );
    },
    onInputBranch(branches) {
      if (!branches.length) {
        this.filter.byRiskBranch.id = null;
      }
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        branches,
        this.filter.byRiskType.id,
      );
    },
    onInputRisk(risks) {
      if (!risks.length) {
        this.filter.byRiskType.id = null;
      }
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        risks,
      );
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}` },
      });
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$store.dispatch("auth/products");
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Prodotto eliminato con successo`,
          });
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.myToggleR = false;
      this.myToggleB = false;
      this.myToggleP = false;
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapGetters("filters", { loadFilterByName: "loadByName" }),
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getRisks: "risks",
      getProducts: "products",
      getBranches: "branches",
    }),
  },
};
</script>
